import React, {useEffect, useState} from "react";
import {
    Layout,
    Breadcrumb,
    Row,
    Col,
    Card,
    Form,
    Input,
    InputNumber,
    Select,
    Button,
    message
} from 'antd';
import Api from "../api.js";
import {useParams} from "react-router-dom"

const {Content} = Layout;

const AppVisitedReport = () => {
    const params = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
    }, [])

    const onFinish = (values: any) => {
        setLoading(true)
        Api.get("/admin/reports/visits?email=" + values.email + "&days=" + values.days + "&timeframe=" + values.more_than, values).then(res => {
            setLoading(false)
            return message.success('Report sent to ' + values.email);
        });
    };

    return (
        <Content style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item>Reports</Breadcrumb.Item>
                <Breadcrumb.Item>Visits</Breadcrumb.Item>
            </Breadcrumb>


                <Col span={24}>
                    <div className="site-layout-card">
                        <h1>App visited report</h1>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Card>
                                    <Form
                                        name="amember_visits"
                                        labelCol={{span: 8}}
                                        wrapperCol={{span: 16}}
                                        initialValues={{remember: true}}
                                        onFinish={onFinish}
                                        autoComplete="off"
                                    >
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{required: true, message: 'Email on nõutud'}]}>
                                            <Input/>
                                        </Form.Item>

                                        <Form.Item
                                            label="Days"
                                            name="days">
                                            <InputNumber
                                                min="1"
                                                step="1"
                                            />
                                        </Form.Item>

                                        <Form.Item label="Timeframe" name="more_than">
                                            <Select
                                                defaultValue="false"
                                                style={{width: 120}}
                                                options={[{value: 'false', label: 'Within'}, {
                                                    value: 'true',
                                                    label: 'More than'
                                                }]}
                                            />
                                        </Form.Item>

                                        <Form.Item wrapperCol={{offset: 8, span: 16}}>
                                            <Button type="primary" htmlType="submit" loading={loading}>
                                                Generate
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Col>
        </Content>
    );
}

export default AppVisitedReport;